"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var BinPacking = /*#__PURE__*/function () {
  function BinPacking(width, height) {
    (0, _classCallCheck2["default"])(this, BinPacking);
    this.MAX_WIDTH = width;
    this.MAX_HEIGHT = height;
    this.itemList = new Map();
    this.spaceList = new Set();
    this.spaceList.add({
      x: 0,
      y: 0,
      w: width,
      h: height
    });
  }
  return (0, _createClass2["default"])(BinPacking, [{
    key: "reset",
    value: function reset() {
      this.spaceList = new Set();
      this.spaceList.add({
        x: 0,
        y: 0,
        w: this.MAX_WIDTH,
        h: this.MAX_HEIGHT
      });
    }
  }, {
    key: "isIntersect",
    value: function isIntersect(r1, r2) {
      if (r1.x >= r2.x + r2.w) {
        return false;
      }
      if (r1.x + r1.w <= r2.x) {
        return false;
      }
      if (r1.y >= r2.y + r2.h) {
        return false;
      }
      if (r1.y + r1.h <= r2.y) {
        return false;
      }
      return true;
    }
  }, {
    key: "isInclude",
    value: function isInclude(r1, r2) {
      if (r2.x >= r1.x && r2.x + r2.w <= r1.x + r1.w && r2.y >= r1.y && r2.y + r2.h <= r1.y + r1.h) {
        return true;
      }
      return false;
    }
  }, {
    key: "getIntersection",
    value: function getIntersection(r1, r2) {
      var rect = {};
      rect.x = Math.max(r1.x, r2.x);
      rect.y = Math.max(r1.y, r2.y);
      rect.w = Math.min(r1.x + r1.w, r2.x + r2.w) - rect.x;
      rect.h = Math.min(r1.y + r1.h, r2.y + r2.h) - rect.y;
      return rect;
    }
  }, {
    key: "check",
    value: function check(item) {
      var isFound = false;
      var findSpace;
      var _iterator = _createForOfIteratorHelper(this.spaceList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var space = _step.value;
          findSpace = space;
          if (item.x || item.y) {
            var _item$x = item.x,
              x = _item$x === void 0 ? 0 : _item$x,
              _item$y = item.y,
              y = _item$y === void 0 ? 0 : _item$y,
              w = item.w,
              h = item.h;
            if (x >= space.x && y >= space.y && w <= space.w && h <= space.h) {
              isFound = true;
              break;
            }
          } else if (item.w <= space.w && item.h <= space.h) {
            isFound = true;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!item.x && !item.y) {
        item.x = findSpace.x;
        item.y = findSpace.y;
      }
      if (isFound) {
        var newList = new Set();
        var _iterator2 = _createForOfIteratorHelper(this.spaceList),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var sp = _step2.value;
            if (this.isInclude(item, sp)) {
              this.spaceList["delete"](sp);
              continue;
            }
            if (this.isIntersect(item, sp)) {
              var rt = {
                x: sp.x,
                y: sp.y,
                w: sp.w,
                h: item.y - sp.y
              };
              var rb = {
                x: sp.x,
                y: item.y + item.h,
                w: sp.w,
                h: sp.y + sp.h - (item.y + item.h)
              };
              var rl = {
                x: sp.x,
                y: sp.y,
                w: item.x - sp.x,
                h: sp.h
              };
              var rr = {
                x: item.x + item.w,
                y: sp.y,
                w: sp.x + sp.w - (item.x + item.w),
                h: sp.h
              };
              if (rt.w > 0 && rt.h > 0) {
                newList.add(rt);
              }
              if (rl.w > 0 && rl.h > 0) {
                newList.add(rl);
              }
              if (rb.w > 0 && rb.h > 0) {
                newList.add(rb);
              }
              if (rr.w > 0 && rr.h > 0) {
                newList.add(rr);
              }
              this.spaceList["delete"](sp);
              continue;
            }
          }

          //remove invalidate spaces
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        var _iterator3 = _createForOfIteratorHelper(this.spaceList),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var s1 = _step3.value;
            var _iterator6 = _createForOfIteratorHelper(newList),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var s2 = _step6.value;
                if (s1 != s2 && this.isInclude(s1, s2)) {
                  newList["delete"](s2);
                  continue;
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var _iterator4 = _createForOfIteratorHelper(newList),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _s = _step4.value;
            var _iterator7 = _createForOfIteratorHelper(newList),
              _step7;
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _s2 = _step7.value;
                if (_s != _s2 && this.isInclude(_s, _s2)) {
                  newList["delete"](_s2);
                  continue;
                }
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        if (newList.size) {
          var _iterator5 = _createForOfIteratorHelper(newList),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var list = _step5.value;
              this.spaceList.add(list);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
        this.spaceList = new Set((0, _toConsumableArray2["default"])(this.spaceList).sort(function (a, b) {
          if (a.x < b.x) {
            return -1;
          } else if (a.x == b.x && a.y < b.y) {
            return -1;
          } else {
            return 1;
          }
        }));
      } else {
        item.x = Math.floor(Math.random() * (this.MAX_WIDTH - 30));
        item.y = Math.floor(Math.random() * (this.MAX_HEIGHT - 30));
      }
      return item;
    }
  }, {
    key: "add",
    value: function add(id) {
      var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
      var h = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
      this.reset();
      var _iterator8 = _createForOfIteratorHelper(this.itemList),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _step8$value = (0, _slicedToArray2["default"])(_step8.value, 2),
            _id = _step8$value[0],
            _item = _step8$value[1];
          this.check((0, _cloneDeep2["default"])(_item));
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      var item = this.check({
        x: x,
        y: y,
        w: w,
        h: h
      });
      this.itemList.set(id, item);
      return item;
    }
  }, {
    key: "replace",
    value: function replace(id) {
      var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var width = arguments.length > 3 ? arguments[3] : undefined;
      var height = arguments.length > 4 ? arguments[4] : undefined;
      var item = this.itemList.get(id) || {};
      item.x = x + 230;
      item.y = y + 105;
      item.w = width;
      item.h = height;
    }
  }, {
    key: "remove",
    value: function remove(id) {
      this.itemList["delete"](id);
    }
  }]);
}();
var _default = exports["default"] = BinPacking;